import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAuthorization = function SvgAuthorization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v128c-35.299 0-64-28.701-64-64s28.591-64 64-64Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.444 115.055c6.137 0 11.111-4.974 11.111-11.111 0-6.136-4.974-11.11-11.11-11.11-6.137 0-11.112 4.974-11.112 11.11 0 6.137 4.975 11.111 11.111 11.111Z",
    stroke: "#0C1733",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.333 66.167 130 59.5l-11.111-11.111 6.667-6.667c2.444-2.444 2.444-6.444 0-8.889-2.445-2.444-6.445-2.444-8.889 0L66.689 82.811A24.327 24.327 0 0 0 54.444 79.5C40.934 79.5 30 90.433 30 103.944c0 13.512 10.933 24.445 24.444 24.445 13.512 0 24.445-10.933 24.445-24.445 0-4.466-1.222-8.644-3.311-12.244l23.31-23.311 8.89 8.889 6.666-6.667-8.888-8.889 6.666-6.666 11.111 11.11Z",
    stroke: "#0C1733",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var Memo = /*#__PURE__*/memo(SvgAuthorization);

export { Memo as default };
//# sourceMappingURL=authorization.svg.js.map
